import { Record } from "immutable";
import { DateStringNumber, Nullable } from "common/records";
import { checkDate } from "common/helpers/Date";

export const wallFacadeFromJSON = (json: Partial<IWallFacadeData>): WallFacadeRecord => {
  const recordData: IWallFacadeRecord = { ...(json as any) };

  if (json.created_at) {
    recordData.created_at = checkDate(json.created_at);
  }

  if (json.updated_at) {
    recordData.updated_at = checkDate(json.updated_at);
  }

  return new WallFacadeRecord(recordData);
};

export interface IWallFacadeData {
  id: number;
  name?: string;
  designator: string;
  ref_id: string;
  location?: string;
  level?: string;
  orientation: number;
  pitch: number;
  area: number;
  ui?: number;
  created_at: DateStringNumber;
  updated_at: DateStringNumber;

  _destroy?: boolean;
}

export interface IWallFacadeRecord {
  id: number;
  name: string;
  designator: string;
  ref_id: string;
  location: string;
  level: string;
  orientation: number;
  pitch: number;
  area: number;
  ui: number;
  created_at: Date;
  updated_at: Date;

  _destroy: Nullable<boolean>;
}

const defaultWallFacadeProps: IWallFacadeRecord = {
  id: 0,
  name: "",
  designator: "",
  ref_id: "",
  location: "",
  level: "",
  orientation: 0,
  pitch: 0,
  area: 0,
  ui: 0,
  created_at: new Date(),
  updated_at: new Date(),
  _destroy: null,
};

export class WallFacadeRecord extends Record(defaultWallFacadeProps) implements IWallFacadeRecord {}
